import { Component, OnInit, Input } from '@angular/core';
import { isHK } from 'app/app.component';
import { AuthService } from 'app/services/auth.service';
import { Oferent } from 'app/model/oferent';
import { CenaMontazu } from 'app/model/cena';
import { MontagePriceService } from 'app/services/montage-price.service';
import { OfferService } from 'app/services/offer.service';

import { NgxCarousel } from 'ngx-carousel';

@Component({
  selector: 'app-new-offer',
  templateUrl: './new-offer.component.html',
  styleUrls: ['./new-offer.component.css']
})
export class NewOfferComponent implements OnInit {

  @Input() model = new Oferent();

  prices: Array<CenaMontazu> = [];
  empty_price = new CenaMontazu();

  public carouselInstallationPrices: NgxCarousel;

  constructor(
    private offerService: OfferService,
    private montagePriceService: MontagePriceService,
    private authService: AuthService) { }

  ngOnInit() {
    this.carouselInstallationPrices = {
      grid: { xs: 1, sm: 1, md: 1, lg: 1, all: 0 },
      slide: 1,
      speed: 400,
      interval: 4000,
      point: {
        visible: true
      },
      load: 2,
      touch: true,
      loop: false,
      custom: 'banner'
    }
  }

  save() {
    if (this.model.nazwa) {
      const __this__ = this;
      if (!this.model.id) {
        this.offerService.saveNew(this.model).then(xx => {
          __this__.model.id = xx.ref.key;
          for (const pr of __this__.prices) {
            pr.dostawca_id = __this__.model.id;
            __this__.montagePriceService.save(pr);
          }
        });
      } else {
        for (const pr of __this__.prices) {
          pr.dostawca_id = __this__.model.id;
          __this__.montagePriceService.save(pr);
        }
      }
      // this.model = new Oferent();
      // this.router.navigate(['/']);
    }
  }

  deletePrice(pr: CenaMontazu) {
    const idx = this.prices.indexOf(pr);
    this.prices.splice(idx);
  }

  newPrice() {
    if (this.empty_price.isFilledCorrectly()) {
      this.prices.push(this.empty_price);
      this.empty_price = new CenaMontazu();
    }
    // this.carouselInstallationPrices.
  }


  cancel() {
    this.offerService.reloadFromDb();
    this.model = new Oferent();
    // this.router.navigate(['/offers']);
  }

  getPrices() {
    return this.prices;
  }

  getIsHK(): boolean {
    return isHK;
  }

  isSuperUser() {
    return this.authService.isSuperUser();
  }

  isAdmin(): boolean {
    return this.authService.isAdmin();
  }
}



// WEBPACK FOOTER //
// /Users/michaldudziak/Desktop/Projekty/Projekt-Sunroof/Sunroof/src/app/new-offer/new-offer.component.ts